import React, { useState } from "react";
import FlightSearchCard from "../FlightSearchCard/FlightSearchCard";
import "./search-v2.scss";
import Newsletter from "../Newsletter/Newsletter";
import AdvisoryBanner from "../AdvisoryBanner/AdvisoryBanner";
import { useAdvisoryBanners } from "../../hooks/useAdvisoryBanners";


export default function SearchV2() {
  const [newsletterChecked, setNewsletterChecked] = useState(false);
  const banners = useAdvisoryBanners();
  return (
    <div className="search-page-container">
      <div className="hero-image display-none-mobile">
        <img alt="flair airlines" src="images/flair-airlines.jpg" />
      </div>

      <div className="search-panel">
        {banners.map((banner, i) => (
          <AdvisoryBanner key={i} banner={banner} />
        ))}
        <FlightSearchCard />
      </div>

      <Newsletter
        newsletterChecked={newsletterChecked}
        setNewsletterChecked={setNewsletterChecked}
      />
    </div>
  );
}
